<template>
  <div>
    <v-list-tile v-if="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-list-tile>
    <v-list-tile v-else avatar @click="showSentences()">
      
      <v-list-tile-avatar>
        <v-icon v-if="biblio.subs" class="primary white--text">collections_bookmark</v-icon>
        <v-icon v-else class="primary white--text">book</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ biblio.title }}</v-list-tile-title>
        <v-list-tile-sub-title>
          {{ $tc('sentences', biblio.sentences.length, { count: biblio.sentences.length }) }}
          <!-- Si pas sous-biblio -->
          <span v-if="biblio.subs">
            {{ $t('and') }}
            {{ $tc('subLibraries', biblio.subs.length, { count: biblio.subs.length }) }}
          </span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action v-if="biblio.id != 0">
        <v-menu bottom left>
          <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="openDialogUpdate()">
              <v-list-tile-action>
                <v-icon>edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('edit') | cap }} {{ $tc(biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' }) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogDelete()">
              <v-list-tile-action>
                <v-icon>delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('delete') | cap }} {{ $tc(biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' }) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>

    <!-- DIALOGUES -->
    <v-dialog v-model="showDialogUpdate" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc(biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' }) }}</v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              :label="$t('edit') + ' ' + $tc('subLibraries', 1, { count: '' }) | cap" 
              v-model="biblioDialog.title"
              max="32" 
              required
              data-vv-name="biblioInput"
              v-validate="'required|max:32'" 
              :error="wzErrors.has('biblioInput')"
              :errors="wzErrors.collect('biblioInput')"
              @keyup.native.enter="submitDialogUpdate"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submit') }}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDelete" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc(biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' }) }}?</v-card-title>
        <v-card-text>
          {{ $t('askRemoveLibrary') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogDelete = false">{{ $t('no') }}</v-btn>
          <v-btn color="primary" @click="submitDialogDelete()">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    biblio: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDelete: false,
      /**
       * indique si la vue affiche les phrases d'une bibliothèque
       * @type {Boolean}
       */
      showSent: false,
      /**
       * bibliothèque qui sera utilisé dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      biblioDialog: {},
      /**
       * loader
       */
      loading: false,
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false
    }
  },

  methods: {
    openDialogUpdate () {
      this.biblioDialog = _.clone(this.biblio)
      this.showDialogUpdate = true
    },
    openDialogDelete () {
      console.log(this.biblio)
      // propose la suppression de la bibliothèque uniquement si elle ne contient pas de sous-bibliothèque
      if (!this.biblio.subs || (this.biblio.subs && !this.biblio.subs.length)) {
        this.biblioDialog = _.clone(this.biblio)
        this.showDialogDelete = true
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Impossible à supprimer : contient ' + this.biblio.subs.length + ' ' + this.$tc('subLibraries', this.biblio.subs.length, { count: this.biblio.subs.length }),
          context: 'warning'
        })
      }
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false
      // s'il y a bien eu une modification
      if ((this.biblio.title !== this.biblioDialog.title)) {
        // recherche de la biblio dans la liste des biblios
        // si elle n'est pas trouvée alors on peut la modifier
        let biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](this.biblioDialog.title)
        if (_.isNil(biblioFound)) {
          let dataToPost = new window.FormData()
          dataToPost.append('FAM_ID', this.biblioDialog.id)
          dataToPost.append('FAM_NAME', this.biblioDialog.title)
          this.loading = true
          this.axios.post('put/biblio.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(response => {
            // modification de la biblio dans la liste des bibliothèques
            this.$store.commit('_Biblios/UPDATE_BIBLIO', this.biblioDialog)
            this.$emit('update:biblio', this.biblioDialog)
            this.$emit('update')
            // Notification
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          })
          .catch(_ => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
          })
          .then(_ => {
            this.loading = false
          })
        } else {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' })
        }
      }
    },
    submitDialogDelete () {
      this.showDialogDelete = false
      let dataToPost = new window.FormData()
      dataToPost.append('FAM_ID', this.biblio.id)
      this.loading = true
      this.axios.post('delete/biblio.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // succès
      .then(response => {
        // suppression de la biblio dans la liste des bibliothèques
        this.$store.commit('_Biblios/REMOVE_BIBLIO', this.biblio)
        this.$emit('update:biblio', this.biblio)
        this.$emit('update')
        this.biblioDialog = {}
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
      })
      // erreur
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    showSentences () {
      console.log('show')
      // pour éviter de réaliser l'évenement si la souris est au-dessus du bouton de click
      if (!this.overMenu) {
        if (this.biblio.subs) {
          this.$router.push({ path: '/media/biblios/' + this.biblio.id })
        } else {
          this.$router.push({ path: '/media/biblios/' + this.biblio.sub + '/sub/' + this.biblio.id })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzBiblio.vue